import { render } from "./Mypage.vue?vue&type=template&id=5ee78f6d"
import script from "./Mypage.vue?vue&type=script&lang=js"
export * from "./Mypage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__